import { render, staticRenderFns } from "./LiveForm.vue?vue&type=template&id=3bb2ce30&"
import script from "./LiveForm.vue?vue&type=script&lang=js&"
export * from "./LiveForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports